import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { getItem } from '../../lib/asyncStorage'

import firebase from 'firebase/app'
import { useRouter } from 'next/router'
import { logMsg } from '../../lib/err'

function CaptainImg({ copyVersion = 1 }) {
  const [captainInfo, setCaptainInfo] = useState()
  const [loading, setLoading] = useState(true)
  const { query } = useRouter()
  useEffect(() => {
    const fetchCaptain = async () => {
      try {
        const getCaptainInfo = firebase.functions().httpsCallable('getCaptainInfo')

        let crewInvite = query.c
        if (crewInvite) {
          const { data } = await getCaptainInfo({ crew: crewInvite })
          setCaptainInfo(data)
        } else {
          let referInvite = query.r
          if (referInvite) {
            const { data } = await getCaptainInfo({ refer: referInvite })
            setCaptainInfo(data)
          }
        }
      } catch (e) {
        logMsg('Failed to fetch captain info in intro')
      } finally {
        setLoading(false)
      }
    }
    fetchCaptain()
  }, [query])

  const initial = captainInfo?.fname.charAt(0).toUpperCase() || ''

  return (
    <div id="captain-img">
      {!loading && captainInfo?.fname ? (
        <div id="has-captain">
          {captainInfo?.photoURL ? (
            <img src={captainInfo.photoURL} alt="captain profile" />
          ) : (
            <div className="initial">
              <p>{initial}</p>
            </div>
          )}
          {captainInfo?.fname && <p>{captainInfo.fname} invited you to join Landslide and vote early with them.</p>})
        </div>
      ) : (
        <div className={copyVersion === 1 ? 'no-crew' : 'no-crew-copy-2'} />
      )}
    </div>
  )
}

CaptainImg.propTypes = {
  copyVersion: PropTypes.number,
}

export default CaptainImg
